import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'pureFunction'
})
export class PureFunctionPipe implements PipeTransform {
  public transform(value: unknown | unknown[], handler: (...args: unknown[]) => unknown): unknown {
    //@ts-ignore
    return handler(...value);
  }
}
